export var openWindow = function (url) {
    window.open(url, "_blank");
};
